import React from "react";
import { Route, Routes } from "react-router-dom";
import * as pages from "./pages/MarketplacePages";

const MarketplaceRoutes = () => (
  <Routes>
    <Route index element={<pages.MarketplaceDashboard />} />
    <Route path="browse" element={<pages.MarketplaceBrowse />} />
    <Route path="listings/new" element={<pages.CreateMaterialListing />} />
    <Route path="listings/import" element={<pages.ImportMaterialListings />} />
    <Route path="listings/:id" element={<pages.MaterialListingDetails />} />
    <Route path="listings/:id/edit" element={<pages.EditMaterialListing />} />
    <Route path="my-listings" element={<pages.MyMaterialListings />} />
    <Route path="reviews" element={<pages.MaterialReviewWorklist />} />
    <Route path="reviews/:id" element={<pages.MaterialReviewDetails />} />
    <Route path="workflows" element={<pages.WorkflowSettings />} />
    <Route path="workflows/new" element={<pages.CreateWorkflow />} />
    <Route path="negotiations" element={<pages.NegotiationWorklist />} />
    <Route path="negotiations/:id" element={<pages.NegotiationDetails />} />
    <Route path="approvals" element={<pages.ApprovalWorklist />} />
    <Route path="approvals/:id" element={<pages.ProcurementApprovalDetails />} />
    <Route path="purchase-orders" element={<pages.PurchaseOrders />} />
    <Route path="purchase-orders/:id" element={<pages.PurchaseOrderDetails />} />
    <Route path="receipts" element={<pages.GoodsReceipts />} />
    <Route path="receipts/:id" element={<pages.GoodsReceiptDetails />} />
    <Route path="stock-posting" element={<pages.StockPostingWorklist />} />
    <Route path="completed" element={<pages.CompletedProcurements />} />
  </Routes>
);

export default MarketplaceRoutes;
